import adminInfo from './adminInfo';

const store = { adminInfo };

export default store;
